import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';

var TAGMobileDotsStepper = function TAGMobileDotsStepper(_ref) {
  var currentStep = _ref.currentStep,
      steps = _ref.steps;

  var _useState = useState(currentStep),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var maxSteps = steps.length;

  var handleNext = function handleNext() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var BUTTONSTYLE = {
    color: 'text.secondary',
    fontFamily: ASPENDENTAL_FONTS.bodySmallBook.fontFamily,
    textTransform: 'capitalize',
    '&.Mui-disabled': {
      color: 'text.disabled'
    },
    ':hover': {
      backgroundColor: 'neutrals.neutral'
    },
    ':active': {
      backgroundColor: 'neutrals.primary'
    }
  };
  return React.createElement(Box, {
    width: '100%'
  }, React.createElement(MobileStepper, {
    variant: "dots",
    steps: maxSteps,
    position: "static",
    activeStep: activeStep,
    sx: {
      '.MuiMobileStepper-dot': {
        margin: '0px 6px',
        backgroundColor: 'neutrals.primary'
      },
      '.MuiMobileStepper-dotActive': {
        backgroundColor: 'secondary.main'
      }
    },
    nextButton: React.createElement(Button, {
      size: "small",
      onClick: handleNext,
      disabled: activeStep === maxSteps - 1,
      endIcon: React.createElement(TAGSvgIcon, {
        icon: "ChevronRightFunc",
        size: 16
      }),
      sx: [BUTTONSTYLE, {
        '.MuiButton-endIcon': {
          marginLeft: '0px'
        }
      }]
    }, "Next"),
    backButton: React.createElement(Button, {
      size: "small",
      onClick: handleBack,
      disabled: activeStep === 0,
      startIcon: React.createElement(TAGSvgIcon, {
        icon: "ChevronLeftFunc",
        size: 16
      }),
      sx: [BUTTONSTYLE, {
        '.MuiButton-startIcon': {
          marginRight: '0px'
        }
      }]
    }, "Back")
  }));
};

export default TAGMobileDotsStepper;